import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
dayjs.extend(customParseFormat);

export default class DateUtil {
    static getStringDiff(now: Date, stringDate?: string): string | undefined {
        if (stringDate) {
            const date = dayjs(stringDate)
            const dateNow = dayjs(now)
            const seconds = dateNow.diff(date, 'seconds')
            return DateUtil.formatSeconds(seconds)
        }
    }

    static formatSeconds(seconds: number) {
        let cad = ''
        let days, hours, minutes
        if (seconds >= 3600 * 24) {
            days = parseInt((seconds / (3600 * 24)).toString())
            seconds = seconds % (3600 * 24)
        }
        if (seconds >= 3600 && seconds < 3600 * 24) {
            hours = parseInt((seconds / 3600).toString())
            seconds = seconds % 3600
        }
        if (seconds >= 60 && seconds < 3600) {
            minutes = parseInt((seconds / 60).toString())
            seconds = seconds % 60
        }
        //Conditions
        if (days) {
            cad = `${days}D ${hours || '0'}H`
        } else {
            if (hours) {
                cad = `${hours}H ${minutes || '0'}m`
            } else if (minutes) {
                cad = `${minutes}m ${seconds}s`
            } else {
                cad = `${seconds}s`
            }
        }
        return cad
    }

    static getGenericFormat(stringDate?: string): string {
        return dayjs(stringDate).format('HH:mm:ss DD/MM/YYYY')
    }

    static formatDateForGetReport(stringDate: string): string{
        return dayjs(stringDate, 'DD-MM-YYYYHH:mm').format('YYYY-MM-DDTHH:mm:ssZ')
    }

}
